module.exports = __webpack_public_path__ + "img/404.223f671c.svg";